export class TdsApplicableReq{
    year:number
}